module.exports = __webpack_public_path__ + "static/img/5.2979522.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/18/sp/5.png
// module id = bzlu
// module chunks = 0